import { Button } from '@/components/ui/button';
import { Lock, Crown, LogIn } from 'lucide-react';
import { goSubscribe } from './LibraryPaywall';

export const openSignIn = () => window.dispatchEvent(new CustomEvent('fbc-auth', { detail: 'login' }));

// Inline lock: `need="registered"` → free sign-in; `need="paid"` → FBC Project Intelligence.
export default function IntelLock({ need = 'paid', title, blurb, compact = false, testid }) {
  const paid = need === 'paid';
  return (
    <div className={`rounded-lg border-2 border-dashed ${compact ? 'p-3' : 'p-5'} text-center bg-muted/20`}
      data-testid={testid || `intel-lock-${need}`}>
      <Lock className="h-4 w-4 mx-auto mb-1.5 text-muted-foreground" />
      {title && <p className="text-sm font-medium">{title}</p>}
      <p className="text-xs text-muted-foreground mt-1 mb-3 max-w-md mx-auto">
        {blurb || (paid
          ? 'Part of FBC Project Intelligence: litigation library, financial filings & AI briefs, court orders and the Project Archive. ₹1,499/year.'
          : 'Sign in free to read this. It takes a minute and keeps you updated on your project.')}
      </p>
      {paid ? (
        <Button size="sm" className="bg-emerald-700 hover:bg-emerald-800 text-white" onClick={goSubscribe} data-testid={`${testid || 'intel-lock'}-subscribe`}>
          <Crown className="h-3.5 w-3.5 mr-1" />Unlock FBC Project Intelligence
        </Button>
      ) : (
        <Button size="sm" variant="outline" onClick={openSignIn} data-testid={`${testid || 'intel-lock'}-signin`}>
          <LogIn className="h-3.5 w-3.5 mr-1" />Sign in free
        </Button>
      )}
    </div>
  );
}
